//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_e',
        data(){
            return{
                form:{
                    room_number:'',
                    is_card:'',
                    entry_time:'',
                    mom_name:'',
                    baby_name:'',
                    sex:'',
                    birth_date:'',
                    birth_week:'',
                    blood_type:'',
                    birth_weight:'',
                    birth_length:'',
                    apgar_score:'',
                    leave_hos_summary:'',
                    use_drug_history:'',
                    allergy_history:'',
                    new_baby_special_case:'',
                    leave_hos_jaundice_num:'',
                    feed_case:'',
                    milk_pow_brand:'',
                    micturition_case_status:'',
                    micturition_num:'',
                    habit_diaper_brand:'',
                    defecation_case_status:'',
                    defecation_num:'',
                    temperature:'',
                    heart_rate_num:'110',
                    breathing_num:'36',
                    entry_weight:'',
                    spotwo:'90',
                    face_colour:'',
                    cry_sound:'',
                    reaction:'',
                    limb:'',
                    limb_tension_activity:'',
                    limb_tension_activity_be_position:'',
                    limb_tension_activity_lose_position:'',
                    birth_injury:'',
                    nerve_reflex_status:'',
                    nerve_reflex_abnormal_desc:'',
                    nutrition_development_status:'',
                    whole_body_skin_status:[],
                    whole_body_skin_be_position:'',
                    whole_body_skin_rash_position:'',
                    whole_body_skin_remark:'',
                    front_fontanelle_status:'',
                    mouth_mucosa_status:'',
                    eye_blood_secretion:'',
                    sclera_yellow_dye:'',
                    nose_shape_status:'',
                    nose_shape_place_name:'',
                    breathing_open_status:'',
                    ear_shape_status:'',
                    ear_shape_place_name:'',
                    abroad_ear_way_shape_status:'',
                    abroad_ear_way_shape_desc:'',
                    umbilicus_abnorma_status:'',
                    navelscab_case_staus:'',
                    suck_case_status:'',
                    hips_status:'',
                    vulva_status:'',
                    vulva_abnormal_case_desc:'',
                    anus_status:'',
                    urethra_crack_status:'',
                    falsex_menstruation_status:'',
                    prevention_inoculation_status:'',
                    prevention_inoculation_has_name:'',
                    jaundice_index_num:'',
                    other_special_case:'',
                    baby_nursing_abstract:'',
                    autograph:'',
                    customer_sign:'',
                    assessment_time:'',
                    prevention_inoculation_bar:[],
                    baby_nursing_check:[]
                },
                showUserSignature:false,
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            save(){
                let signature ='signature1'
                const sigRef = this.$refs[signature]
                const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
                if (!comp || !comp.save) return
                let png = comp.save()
                this.form.autograph = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.autograph = ''
            },
            clear(){
                let signature ='signature1'
                const sigRef = this.$refs[signature]
                if (Array.isArray(sigRef)) {
                    sigRef.forEach(c => c && c.clear && c.clear())
                } else if (sigRef && sigRef.clear) {
                    sigRef.clear()
                }
                this.form.autograph = ''
            },
              // 保存客户签名
             saveUserName(){
                let signature ='signature2'
                const sigRef = this.$refs[signature]
                const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
                if (!comp || !comp.save) return
                let png = comp.save()
                this.form.customer_sign = encodeURI(png)
                this.showUserSignature = true
            },
            //编辑客户签名
            editUserName(){
                this.showUserSignature = false
                 this.form.customer_sign = ''
            },
            //清除客户签名
            clearUserName(){
                let signature ='signature2'
                const sigRef = this.$refs[signature]
                if (Array.isArray(sigRef)) {
                    sigRef.forEach(c => c && c.clear && c.clear())
                } else if (sigRef && sigRef.clear) {
                    sigRef.clear()
                }
                this.form.customer_sign = ''
            },
            submitForm(){
                this.form.token=this.$cookie.get('token')
                this.form.number_id=this.$cookie.get('id')
                this.form.maternal_info_id=this.$route.query.id
                this.form.store_id=this.$cookie.get('store_id')
                this.form.baby_id=this.$route.query.child_id
                let params = this.form
                   
                if(
                    params.room_number==''||params.is_card==''||params.entry_time==''||params.mom_name==''||params.baby_name==''||params.sex==''||params.birth_date==''||params.birth_week==''||
                    params.blood_type==''||params.birth_weight==''||params.birth_length==''||params.apgar_score==''||params.leave_hos_summary==''||params.use_drug_history==''||
                    params.allergy_history==''||params.new_baby_special_case==''||params.leave_hos_jaundice_num==''||params.feed_case==''||params.micturition_case_status==''||
                    params.micturition_num==''||params.habit_diaper_brand==''||params.defecation_case_status==''||params.temperature==''||
                    params.heart_rate_num==''||params.breathing_num==''||params.entry_weight==''||params.spotwo==''||params.face_colour==''||
                    params.cry_sound==''||params.reaction==''||params.limb==''||params.limb_tension_activity==''||
                    params.birth_injury==''||params.nerve_reflex_status==''||params.nutrition_development_status==''||
                    params.whole_body_skin_status.length==0||params.front_fontanelle_status==''||
                    params.mouth_mucosa_status==''||params.eye_blood_secretion==''|| params.sclera_yellow_dye==''||params.nose_shape_status==''||params.breathing_open_status==''||
                    params.ear_shape_status==''||params.abroad_ear_way_shape_status==''||params.umbilicus_abnorma_status==''||params.navelscab_case_staus==''||
                    params.suck_case_status==''||params.hips_status==''||params.vulva_status==''||
                    params.anus_status==''||params.urethra_crack_status==''||params.falsex_menstruation_status==''||params.prevention_inoculation_status==''||
                    params.jaundice_index_num==''||params.other_special_case==''||params.autograph==''||params.assessment_time==''||params.baby_nursing_check.length==0||params.customer_sign==''
                ){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请完善表单',
                    })
                    return
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.otherFormApi.addNewBornCheckAssessData(params).then ( res => {
                    this.$vux.loading.hide()
                    console.info(res)
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                tabVal: this.$route.query.tabVal,
                                form_id:res.data.id,
                                name : 'bb_form_e',
                            }
                        })
                    }
                })  
            },
              apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.mom_name = res.data.name
                        this.form.room_number = res.data.room_name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        let get_boby_id = this.$route.query.child_id
                        for(let item of res.data){
                            if(item.id == get_boby_id){
                                this.form.is_card = item.hand_card
                                // this.form.birth_length = item.weight
                                this.form.baby_name=item.name
                                this.form.sex=item.sex == '1' ? '男' : '女'
                            }
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            }
        },
        created(){
            this.apiMemberInfo()
            this.get_baby_list()
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_e.vue